import useCustomModal, {UseCustomModalProps} from "./useCustomModal";
import {IPopulatedCutter, IPopulatedJob} from "../../types/FrontendTypes.ts";
import {Box, Typography} from "@mui/material";
import JobRest from "../../rest/JobRest.ts";
import React from "react";
import ImageRest from "../../rest/ImageRest.ts";
import {ModalJobCard} from "./ModalCards/ModalJobCard.tsx";
import {ModalCutterCard} from "./ModalCards/ModalCutterCard.tsx";
import {ElectricBolt} from "@mui/icons-material";
import CutterRest from "../../rest/CutterRest.ts";

export interface InterruptCutterModalProps {
    cutter?: IPopulatedCutter;
    cutterRest: CutterRest;
    jobRest: JobRest;
    imageRest: ImageRest;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    afterInterrupt?: (newJob: any) => void;
}

export const useInterruptCutterModal = (props: InterruptCutterModalProps) => {
    const {cutter, jobRest, cutterRest, imageRest, afterInterrupt} = props;
    let modalOptions: UseCustomModalProps;

    const [job, setJob] = React.useState<IPopulatedJob | null>(null);

    React.useEffect(() => {
        if (cutter && cutter.state) {
            jobRest.getById(cutter.state.jobId)
                .then(response => setJob(response.data.data));
        }
    }, [cutter, cutter?.state.jobId, jobRest]);


    if (cutter && job) {
        const content = <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
            <Typography>The cutter</Typography>
            <ModalCutterCard cutter={cutter} imageRest={imageRest}/>
            <Typography>is currently executing this job:</Typography>
            <ModalJobCard job={job} imageRest={imageRest}/>
            <Typography>Interrupting the cutter will abort the job execution.</Typography>
        </Box>;

        modalOptions = {
            title: "Confirm interrupt",
            customContent: content,
            defaultAction: {
                label: "Interrupt",
                method: () => cutterRest.interrupt(cutter._id).then(afterInterrupt),
                icon: <ElectricBolt/>,
                color: "error"
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    } else if (cutter) {
        const content = <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
            <Typography>The cutter</Typography>
            <ModalCutterCard cutter={cutter} imageRest={imageRest}/>
            <Typography>is currently busy. Are you sure, that you want to interrupt it?</Typography>
        </Box>;

        modalOptions = {
            title: "Confirm interrupt",
            customContent: content,
            defaultAction: {
                label: "Interrupt",
                method: () => cutterRest.interrupt(cutter._id).then(afterInterrupt),
                icon: <ElectricBolt/>,
                color: "error"
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    } else {
        modalOptions = {
            title: "Error",
            contentText: "The cutter data is not available. Please try again later.",
            defaultAction: {
                label: "Close",
                method: () => {
                },
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    }

    const {open} = useCustomModal(modalOptions);

    return open;
};

export default useInterruptCutterModal;